const article = {
  id: "kak-popast-v-moyu-volnu",
  metaTitle: "Как попасть в «Мою волну» в Яндекс Музыке: разбор | Boostclick",
  metaDescription: "Какие сигналы называет команда рекомендаций Яндекс Музыки, кому доступно Нитро, зачем нужен питчинг и почему первые дни после релиза важнее всего остального.",
  type: "Гайд",
  category: "Музыка",
  title: "Как попасть в «Мою волну»: что влияет на рекомендации",
  time: 7,
  data: "31.07.2026",
  imageUrl: "/blogImages/kak-popast-v-moyu-volnu/backgroundImage.svg",
  hasDescriptionHeader: true,
  description: `Что известно о рекомендациях Яндекс Музыки из официальных
  источников, а что придумано в статьях подрядчиков: перечень учитываемых
  сигналов без выдуманной иерархии, условия попадания в Нитро, сроки питчинга
  и список утверждений, которым не стоит верить.`,
  navigation: [
    { to: "chto-takoe-moya-volna", text: "Что такое «Моя волна»" },
    { to: "kakie-signaly", text: "Какие сигналы учитываются" },
    { to: "nitro", text: "Нитро: кому доступно" },
    { to: "pitching", text: "Питчинг и его сроки" },
    { to: "pervye-dni", text: "Почему решают первые дни" },
    { to: "chto-mozhet-artist", text: "Что артист может сделать сам" },
    { to: "mify", text: "Чему не стоит верить" },
    { to: "korotko", text: "Коротко" },
  ],
  section: [
    {
      id: "chto-takoe-moya-volna",
      title: "Что такое «Моя волна» и почему она важна",
      content: [
        {
          type: "Definition",
          title: "«Моя волна»",
          text: " — персональный поток Яндекс Музыки, который подбирает треки под конкретного слушателя. Для артиста это основной канал, по которому его музыку находят люди, никогда о нём не слышавшие.",
        },
        {
          type: "Description",
          parts: [
            "Масштаб канала виден по данным, которые Яндекс раскрывал в конце октября 2025 года: месячная аудитория сервиса — 30,5 млн человек, с рекомендательной системой ежемесячно взаимодействуют 90% пользователей мобильного приложения, и каждый второй трек, который слушатели добавляют в коллекцию, приходит именно из рекомендаций (",
            { href: "https://www.sostav.ru/publication/auditoriya-yandeks-muzyki-prevysila-30-5-mln-chelovek-v-mesyats-79308.html", text: "Sostav, 30.10.2025" },
            ").",
          ],
        },
        {
          type: "Description",
          text: "Практический вывод для артиста простой: алгоритмические рекомендации дают больше, чем любые внешние переходы на карточку трека. Поэтому вопрос «как туда попасть» и стоит первым.",
        },
      ],
    },
    {
      id: "kakie-signaly",
      title: "Какие сигналы учитывает алгоритм",
      content: [
        {
          type: "Description",
          text: "Команда рекомендаций Яндекс Музыки в публичных интервью называла набор сигналов, на которые опирается подбор:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "лайки и дизлайки," },
            { text: "скипы и дослушивания," },
            { text: "повторные прослушивания," },
            { text: "поиск артиста по имени," },
            { text: "время взаимодействия с треком," },
            { text: "возвращаемость к треку," },
            { text: "анализ самого звучания композиции." },
          ],
        },
        {
          type: "Subtotal",
          title: "Чего в этом перечне нет",
          text: "Иерархии. Яндекс никогда не публиковал, что весит больше — лайк или дослушивание. Любой текст, где такая иерархия расписана, придумал её сам.",
        },
        {
          type: "Description",
          text: "Про дослушивания стоит сказать отдельно. Отраслевым стандартом засчитанного прослушивания считаются 30 секунд, но собственный порог Яндекс публично не раскрывает. Поэтому корректная формулировка — «удержание в начале трека имеет значение», а не конкретная цифра, за которой якобы что-то щёлкает.",
        },
      ],
    },
    {
      id: "nitro",
      title: "Нитро: отдельный механизм для небольших артистов",
      content: [
        {
          type: "Description",
          parts: [
            "Нитро — технология, которая, по официальному описанию, «не подбирает песни слушателям, а находит слушателей, которым понравится ваш трек». Доступна артистам, чья месячная аудитория не превышает 5 000 слушателей (",
            { href: "https://yandex.ru/support/music/ru/performers-and-copyright-holders/nitro", text: "справка Яндекс Музыки" },
            ").",
          ],
        },
        {
          type: "Description",
          text: "Условия участия: релиз выпущен через дистрибьютора, подан на питчинг и получил позитивную реакцию первых слушателей — дослушивания и лайки. То есть механизм не отменяет необходимости стартовой реакции, а опирается на неё.",
        },
        {
          type: "Footnote",
          textItalic: "Порог в 5 000 слушателей работает в обе стороны: как только аудитория выросла, этот инструмент перестаёт быть доступен. Для начинающего артиста это аргумент не откладывать первые релизы.",
        },
      ],
    },
    {
      id: "pitching",
      title: "Питчинг и его сроки",
      content: [
        {
          type: "Description",
          parts: [
            "Питчинг — официальная подача релиза редакции через BandLink. В справке он описан как возможность «привлечь алгоритмы стриминга, залететь в рекомендации и найти новых слушателей» (",
            { href: "https://yandex.ru/support/music/ru/performers-and-copyright-holders/new-release", text: "справка Яндекс Музыки" },
            "). Это бесплатно, и это официальный способ обратить на релиз внимание платформы до его выхода.",
          ],
        },
        {
          type: "Description",
          text: "Сроки, которые важно не пропустить:",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "Минимум две недели ", text: "до даты выхода — столько времени рекомендуется дать дистрибьютору." },
            { bold: "2–4 дня ", text: "после подтверждения релиза — примерно через столько появляется кнопка питчинга." },
            { bold: "До дня выхода ", text: "нужно успеть подать сингл, чтобы он мог участвовать в Нитро." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Полный порядок подготовки с привязкой к датам — в отдельном материале: ",
            { to: "/blog/kalendar-reliza", text: "календарь релиза по неделям" },
            ".",
          ],
        },
      ],
    },
    {
      id: "pervye-dni",
      title: "Почему решают первые дни",
      content: [
        {
          type: "Description",
          text: "Рекомендательная система показывает новый трек небольшой части слушателей и смотрит, что произойдёт. Дальнейшее распространение зависит от этой первой реакции. Поэтому активность в день выхода и в ближайшие дни стоит дороже, чем та же активность через месяц: через месяц решение уже принято.",
        },
        {
          type: "Description",
          parts: [
            "Отсюда практическое следствие: то, что можно сделать до релиза, важнее того, что можно сделать после. Предварительные сохранения срабатывают одновременно в момент публикации — по данным BandLink, 43% из них приводят к прослушиваниям в первый день и 61% в первую неделю, а сам пресейв втрое увеличивает шансы артистов с аудиторией до 100 тысяч попасть в «Мою волну» (",
            { href: "https://bandlink.media/bandlink_research/presave", text: "BandLink Research" },
            "). Это данные самой платформы, методологию она не раскрывает — но других публичных цифр по пресейвам в русскоязычном стриминге просто нет.",
          ],
        },
        {
          type: "Description",
          parts: [
            "Как устроен этот инструмент и как сделать ссылку — в статье про ",
            { to: "/blog/presave-yandex-music-kak-nastroit", text: "настройку пресейва" },
            ". Заказать задания живым слушателям на предварительное сохранение можно на странице ",
            { to: "/prodvizhenie-trekov-yandexmusic-presave", text: "пресейв альбома в Яндекс Музыке" },
            ".",
          ],
        },
      ],
    },
    {
      id: "chto-mozhet-artist",
      title: "Что артист может сделать сам",
      content: [
        {
          type: "Description",
          text: "Список короткий, зато полностью в вашей зоне влияния — в отличие от решений алгоритма.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ol",
          items: [
            { bold: "Верифицировать карточку артиста. ", text: "Без верификации недоступна аналитика, а значит вы не увидите, что вообще происходит с релизом." },
            { bold: "Проверить метаданные. ", text: "Имя исполнителя и название трека должны выглядеть на платформе ровно так, как вы их пишете везде: расхождение в одну букву ломает и поиск, и статистику." },
            { bold: "Подать релиз на питчинг. ", text: "Бесплатно, делается через BandLink, пропускается чаще всего просто по незнанию." },
            { bold: "Собрать стартовую реакцию. ", text: "Предварительные сохранения, анонсы, рассылка по своей аудитории — всё, что даёт живую реакцию в первые часы." },
            { bold: "Не оставлять каталог пустым. ", text: "Слушатель, которому понравился трек, идёт смотреть, что ещё есть у артиста. Метрика «суперфаны» в BandLink считает тех, кто послушал минимум три ваших трека за 28 дней, — с одним треком в каталоге она недостижима." },
            { bold: "Держать регулярность. ", text: "Один релиз раз в два года не даёт алгоритму данных для работы." },
          ],
        },
      ],
    },
    {
      id: "mify",
      title: "Чему не стоит верить",
      content: [
        {
          type: "Description",
          text: "Эти утверждения кочуют по статьям и коммерческим страницам, но подтверждения у них нет.",
          style: { marginBottom: "8px" },
        },
        {
          type: "List",
          listType: "ul",
          items: [
            { bold: "«Нужно N прослушиваний, чтобы попасть в рекомендации». ", text: "Официального порога не существует. Названная цифра — всегда чья-то догадка." },
            { bold: "«Лайк весит больше дослушивания» (или наоборот). ", text: "Иерархию факторов Яндекс не публиковал." },
            { bold: "«Прослушивание засчитывается ровно после 30 секунд». ", text: "Это отраслевой стандарт, документированный для другой платформы. Свой порог Яндекс не раскрывает." },
            { bold: "«Мы гарантируем попадание в „Мою волну“». ", text: "Решение принимает платформа. Гарантировать его не может ни один сервис — включая наш." },
            { bold: "Описания механики «Плейлиста дня» и редакционных подборок. ", text: "Официальных описаний нет, всё остальное — реконструкция по слухам." },
          ],
        },
        {
          type: "Description",
          parts: [
            "Сюда же относится зеркальный миф — «за накрутку прослушиваний банит Яндекс Музыка». В правилах площадки таких пунктов нет, а реальные последствия описаны в документах дистрибьюторов: ",
            { to: "/blog/nakrutka-proslushivaniy-pravila-distributorov", text: "что на самом деле грозит за искусственные прослушивания" },
            ".",
          ],
        },
        {
          type: "Footnote",
          textItalic: "Простой фильтр: если утверждение нельзя привязать к справке платформы или к публичному интервью с датой — это мнение, а не факт, и планировать релиз по нему не стоит.",
        },
      ],
    },
    {
      id: "korotko",
      title: "Коротко",
      content: [
        {
          type: "List",
          listType: "ul",
          items: [
            { text: "«Моя волна» — основной канал открытия новой музыки: каждый второй добавленный в коллекцию трек приходит из рекомендаций." },
            { text: "Известен перечень сигналов, но не их иерархия. Кто пишет про веса — придумывает." },
            { text: "Нитро доступно артистам с аудиторией до 5 000 слушателей в месяц." },
            { text: "Питчинг бесплатный, но у него жёсткие сроки: релиз дистрибьютору минимум за две недели, сингл на питчинг — до дня выхода." },
            { text: "Первые дни после релиза стоят дороже всего: дальше алгоритм уже принял решение." },
            { text: "Верификация, метаданные, питчинг, стартовая реакция и наполненный каталог — то, чем управляет сам артист." },
          ],
          classes: ["nomargin"],
        },
      ],
    },
  ],
};

export default article;
